import { render, staticRenderFns } from "./StatWithdrawal.vue?vue&type=template&id=5bdff797&scoped=true&"
import script from "./StatWithdrawal.vue?vue&type=script&lang=js&"
export * from "./StatWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdff797",
  null
  
)

export default component.exports